exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".alert[data-v-1aeda9da]{font-size:.75rem;margin-top:.25rem;text-transform:capitalize}.alert-danger[data-v-1aeda9da]{--text-opacity:1;color:#fc8181;color:rgba(252,129,129,var(--text-opacity))}", ""]);

// exports
